import { monaRequest } from "../utils";
import { Params } from '../types'

export function getTaskDetail (params: Params) {
  return monaRequest('/p/api/ota/v1/getTaskDetail', params)
}

export function getTaskProgress (params: Params) {
  return monaRequest('/p/api/ota/v1/getTaskProgress', params)
}

export function saveScheduleTime (params: Params) {
  return monaRequest('/p/api/ota/v1/saveScheduleTime', params)
}

export function cancelScheduleTime (params: Params) {
  return monaRequest('/p/api/ota/v1/cancelScheduleTime', params)
}

export function awakenVehicle (params: Params) {
  return monaRequest('/p/api/rvc/v1/awakenVehicle', params)
}

export function startConditionCheck (params: Params) {
  return monaRequest('/p/api/ota/v1/startConditionCheck', params)
}